'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _BreadCrumbs = require('./components/BreadCrumbs');

var _BreadCrumbs2 = _interopRequireDefault(_BreadCrumbs);

var _CopyWrapper = require('./components/CopyWrapper');

var _CopyWrapper2 = _interopRequireDefault(_CopyWrapper);

var _Description = require('./components/Description');

var _Description2 = _interopRequireDefault(_Description);

var _HeroContainer = require('./components/HeroContainer');

var _HeroContainer2 = _interopRequireDefault(_HeroContainer);

var _Wrapper = require('./components/Wrapper');

var _Wrapper2 = _interopRequireDefault(_Wrapper);

var _Title = require('./components/Title');

var _Title2 = _interopRequireDefault(_Title);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
# Hero
The hero section to be used throughout the site
 */
var Hero = function Hero(_ref) {
  var imgSrc = _ref.imgSrc,
      _ref$title = _ref.title,
      title = _ref$title === undefined ? '' : _ref$title,
      _ref$description = _ref.description,
      description = _ref$description === undefined ? '' : _ref$description,
      _ref$descriptionColor = _ref.descriptionColor,
      descriptionColor = _ref$descriptionColor === undefined ? 'lightGray' : _ref$descriptionColor,
      breadcrumbs = _ref.breadcrumbs,
      height = _ref.height;
  return _react2.default.createElement(
    _HeroContainer2.default,
    {
      height: height,
      $backgroundImage: '' + imgSrc
    },
    _react2.default.createElement(
      _Wrapper2.default,
      null,
      _react2.default.createElement(
        _CopyWrapper2.default,
        {
          $padded: !!(title || description) && height > 1
        },
        _react2.default.createElement(_Title2.default, {
          title: title,
          height: height
        }),
        _react2.default.createElement(_BreadCrumbs2.default, {
          links: breadcrumbs,
          height: height
        }),
        height > 3 && _react2.default.createElement(
          _Description2.default,
          {
            color: descriptionColor
          },
          description
        )
      )
    )
  );
};

Hero.propTypes = {
  /** a URL for the hero image. */
  imgSrc: _propTypes2.default.string.isRequired,
  /** the title. */
  title: _propTypes2.default.string,
  /** the description. */
  description: _propTypes2.default.string,
  /** the description color for mobile screen sizes. */
  descriptionColor: _propTypes2.default.oneOf(['white', 'lightGray']),
  /** the breadcrumbs. */
  breadcrumbs: _propTypes2.default.arrayOf(Object).isRequired,
  /** the height level (1-6). */
  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]).isRequired
};

Hero.displayName = 'Hero';

exports.default = Hero;
Hero.__docgenInfo = {
  'description': '# Hero\r\nThe hero section to be used throughout the site',
  'methods': [],
  'displayName': 'Hero',
  'props': {
    'title': {
      'defaultValue': {
        'value': '\'\'',
        'computed': false
      },
      'type': {
        'name': 'string'
      },
      'required': false,
      'description': 'the title.'
    },
    'description': {
      'defaultValue': {
        'value': '\'\'',
        'computed': false
      },
      'type': {
        'name': 'string'
      },
      'required': false,
      'description': 'the description.'
    },
    'descriptionColor': {
      'defaultValue': {
        'value': '\'lightGray\'',
        'computed': false
      },
      'type': {
        'name': 'enum',
        'value': [{
          'value': '\'white\'',
          'computed': false
        }, {
          'value': '\'lightGray\'',
          'computed': false
        }]
      },
      'required': false,
      'description': 'the description color for mobile screen sizes.'
    },
    'imgSrc': {
      'type': {
        'name': 'string'
      },
      'required': true,
      'description': 'a URL for the hero image.'
    },
    'breadcrumbs': {
      'type': {
        'name': 'arrayOf',
        'value': {
          'name': 'custom',
          'raw': 'Object'
        }
      },
      'required': true,
      'description': 'the breadcrumbs.'
    },
    'height': {
      'type': {
        'name': 'union',
        'value': [{
          'name': 'string'
        }, {
          'name': 'number'
        }]
      },
      'required': true,
      'description': 'the height level (1-6).'
    }
  }
};